var e = React.createElement;

export default class AddSource extends React.Component {
    constructor(props) {
        super(props);
        this.dataI18nKeys = ["source-add-source"];
    }
    
    componentDidMount(){
        for(var key in this.dataI18nKeys){
            globalFunctions.applyTranslatedMessage(this.dataI18nKeys[key],
                                "[data-i18n=" + this.dataI18nKeys[key] + "]");
        }
    }
    
    render() {
        return(<div className="two wide column">
                <div className="btn-block">
                    <button onClick={() => this.props.addSource(this.props.parentId, this.props.viewId)}
                            className="ui labeled icon button primary-btn positive add-source basic">
                                <i className="add icon"></i>
                                <span data-i18n={this.dataI18nKeys[0]}>Add source</span>
                    </button>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./frontend/web/js/AddSource.js